export default __webpack_public_path__ + "static/media/logo.c2338957.png";